'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var CheckboxGroup = (_temp = _class = function (_Component) {
  _inherits(CheckboxGroup, _Component);

  function CheckboxGroup(props) {
    _classCallCheck(this, CheckboxGroup);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CheckboxGroup).call(this, props));

    _initialiseProps.call(_this);

    var model = _this.getOptions(props.model);
    _this.state = {
      model: model,
      value: _this._getRenderValue(props.value, model),
      valid: true,
      explain: ''
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //只在这个时候来初始值
      var defaultValue = this.props.defaultValue;

      if (!(0, _data.isEmptyString)(defaultValue) && this.state.value.length === 0) {
        var value = this._getRenderValue(defaultValue);
        this.setState({ value: value });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state = this.state;
      var value = _state.value;
      var model = _state.model;

      if ('value' in nextProps && nextProps.value !== undefined) {
        value = this._getRenderValue(nextProps.value);
      }
      if ('model' in nextProps) {
        model = this.getOptions(nextProps.model);
      }
      this.setState({
        value: value,
        model: model
      });
    }

    /**
     * 当选中的值变化时
     * @param option 操作的条目
     * @param isCheck
     * @param e
     * @private
     */


    /**
     * 全选/全不选
     * @param isCheck 是否全选
     * @param e
     */


    // 返回一个数组, 筛选出有效的选中值

    // 是否符合返回字符串的条件

  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;
      var className = props.className;
      var style = props.style;
      var disabled = props.disabled;
      var mode = props.mode;
      var emptyLabel = props.emptyLabel;
      var size = props.size;
      var name = props.name;
      var showCheckall = props.showCheckall;
      var disableIfOverLength = props.disableIfOverLength;
      var maxLength = props.maxLength;
      var format = props.format;
      var _state2 = this.state;
      var value = _state2.value;
      var valid = _state2.valid;
      var model = _state2.model;

      var groupClassName = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls + '-checkbox-group', true), _defineProperty(_classNames, prefixCls + '-checkbox-group-sm', size === 'small'), _defineProperty(_classNames, prefixCls + '-checkbox-group-view', mode === 'view'), _defineProperty(_classNames, 'has-error', !valid), _classNames));
      if (mode === 'view') {
        var showLabel = [];
        if (value && model.length > 0) {
          if (format && _lodashCompat2.default.isFunction(format)) {
            showLabel = _react2.default.createElement(
              'div',
              null,
              (model.filter(function (option) {
                return value.indexOf(option.value) !== -1;
              }) || []).map(function (v, k) {
                return _react2.default.createElement(
                  'div',
                  { className: prefixCls + '-checkbox-group-format', key: k },
                  (0, _data.getComponent)(format, _extends({}, v, { index: k }))
                );
              })
            );
          } else {
            showLabel = (model.filter(function (option) {
              return value.indexOf(option.value) !== -1;
            }) || []).map(function (v) {
              return v.label;
            }).join();
          }
        }
        return _react2.default.createElement(
          'div',
          { className: groupClassName, style: style },
          _react2.default.createElement(
            'label',
            { className: 'checkbox-group-label' },
            _lodashCompat2.default.isEmpty(showLabel) ? emptyLabel : showLabel
          )
        );
      }
      var disableUnSelectedItems = disableIfOverLength && value.length >= maxLength;
      var checkallContent = void 0;
      if (showCheckall) {
        var isCheckedAll = model.every(function (item) {
          return value.some(function (v) {
            return v === item.value;
          });
        });
        checkallContent = _react2.default.createElement(_Checkbox2.default, { size: size,
          className: prefixCls + '-checkbox-group-item ' + prefixCls + '-checkbox-checkall',
          disabled: disabled || !isCheckedAll && disableUnSelectedItems || false,
          checked: isCheckedAll,
          onChange: this._checkallHandler,
          label: '全选'
        });
      }
      return _react2.default.createElement(
        'div',
        { className: groupClassName, style: style },
        checkallContent,
        (model || []).map(function (option, index) {
          var isSelected = (value || []).indexOf(option.value) !== -1,
              ctx = option.label;
          if (format && _lodashCompat2.default.isFunction(format)) {
            ctx = (0, _data.getComponent)(format, _extends({}, option, { index: index }));
          }
          return _react2.default.createElement(
            _Checkbox2.default,
            { key: option.value,
              size: size,
              name: name,
              className: prefixCls + '-checkbox-group-item',
              disabled: disabled || !isSelected && disableUnSelectedItems || option.disabled || false,
              checked: isSelected,
              onChange: _this2._changeHandle.bind(_this2, option) },
            ctx
          );
        }),
        !this.state.valid && _react2.default.createElement(
          'div',
          { className: 'has-explain ' + prefixCls + '-explain' },
          this.state.explain
        )
      );
    }

    /**
     * 获取当前展示的可选项
     * @returns {Array}
     */


    /**
     * 校验 外部校验时所有的都触发
     */


    /**
     * 重置 如果设置过默认的值得话,回到默认值的状态
     */

    /**
     * 清空异常状态  校验提示等
     */

  }]);

  return CheckboxGroup;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  mode: _propTypes2.default.oneOf(['default', 'view']),
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.bool]),
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.bool]),
  disabled: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  required: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  validator: _propTypes2.default.func,
  validation: _propTypes2.default.string,
  showCheckall: _propTypes2.default.bool,
  returnStringIfOnlyChild: _propTypes2.default.bool,
  emptyLabel: _propTypes2.default.string,
  model: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func,
  maxLength: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  overLengthValidation: _propTypes2.default.string,
  minLength: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  lessLengthValidation: _propTypes2.default.string,
  disableIfOverLength: _propTypes2.default.bool
}, _class.defaultProps = {
  prefixCls: 'mt', // 样式前缀
  mode: "default", // 控件状态，可选值为 default|view 或者不设
  defaultValue: [], // 默认选中的选项
  disabled: false, // 是否禁用
  required: false, // 是否必填
  validator: null, // 自定义校验事件
  validation: '', // 校验失败后的提示
  showCheckall: false, // 是否显示全选
  returnStringIfOnlyChild: true, // 如果只有一条可选项,那么返回 string 而不是 array
  emptyLabel: '', // mode 为 view 的情况下, 当前值为空时显示的文本
  model: [], // 指定的可选项
  onChange: _data.noop, // 变化时的回调函数
  maxLength: Infinity, // 最大可选个数
  minLength: 0, // 最小需要选择多少个
  lessLengthValidation: "低于最少需选个数", // 少于最小需选个数时的报错信息
  overLengthValidation: "超过最大可选个数", // 超过最大可选个数时的报错信息
  disableIfOverLength: false }, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._changeHandle = function (option, e) {
    var _props = _this3.props;
    var onChange = _props.onChange;
    var returnStringIfOnlyChild = _props.returnStringIfOnlyChild;
    var maxLength = _props.maxLength;
    var disableIfOverLength = _props.disableIfOverLength;

    var value = Array.from((0, _data.toArray)(_this3.state.value));
    var optionIndex = value.indexOf(option.value);
    if (optionIndex === -1) {
      value.push(option.value);
    } else {
      value.splice(optionIndex, 1);
    }
    if (value.length > maxLength && disableIfOverLength) {
      return;
    }
    // 如果是通过 value 传进来选中的值得话,直接外派触发变化 否则的话变化本身的 state
    if (!('value' in _this3.props)) {
      _this3.setState({
        value: value
      });
    }
    // 只有一项时回传的数据
    if (returnStringIfOnlyChild && _this3.state.model.length === 1) {
      value = (0, _data.getSafetyString)(value[0]);
    }
    onChange(value, e);
    _lodashCompat2.default.defer(_this3.validate);
  };

  this._checkallHandler = function (e) {
    var _props2 = _this3.props;
    var onChange = _props2.onChange;
    var returnStringIfOnlyChild = _props2.returnStringIfOnlyChild;
    var maxLength = _props2.maxLength;
    var disableIfOverLength = _props2.disableIfOverLength;

    var isCheck = e.target.checked;
    var value = isCheck ? _this3.state.model.map(function (item) {
      return item.value;
    }) : [];
    // 如果是通过 value 传进来选中的值得话,直接外派触发变化 否则的话变化本身的 state
    if (!('value' in _this3.props)) {
      _this3.setState({
        value: value
      });
    }
    if (value.length > maxLength && disableIfOverLength) {
      return;
    }
    // 只有一项时回传的数据
    if (returnStringIfOnlyChild && _this3.state.model.length === 1) {
      value = (0, _data.getSafetyString)(value[0]);
    }
    onChange(value, e);
    _lodashCompat2.default.defer(_this3.validate);
  };

  this._getRenderValue = function (value, model) {
    model = model || _this3.state.model || [];
    if (_this3._isReturnString(model) && !Array.isArray(value)) {
      // 如果说没有存在在可选项中, 那么置空
      value = [value];
    }
    if (!Array.isArray(value)) {
      value = [];
    }
    value = value.filter(function (v) {
      return model.some(function (x) {
        return x.value === v;
      });
    });
    return value;
  };

  this._isReturnString = function (model) {
    model = model || _this3.state.model || [];
    return _this3.props.returnStringIfOnlyChild && model.length === 1;
  };

  this.getOptions = function (model) {
    return (model || _this3.state.model || []).map(function (option) {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option
        };
      }
      return option;
    });
  };

  this.validate = function () {
    var _props3 = _this3.props;
    var mode = _props3.mode;
    var required = _props3.required;
    var validation = _props3.validation;
    var validator = _props3.validator;
    var maxLength = _props3.maxLength;
    var overLengthValidation = _props3.overLengthValidation;
    var minLength = _props3.minLength;
    var lessLengthValidation = _props3.lessLengthValidation;
    var _state3 = _this3.state;
    var _state3$model = _state3.model;
    var model = _state3$model === undefined ? [] : _state3$model;
    var _state3$value = _state3.value;
    var value = _state3$value === undefined ? [] : _state3$value;

    if (mode === 'view') {
      !_this3.state.valid && _this3.setState({ valid: true });
      return true;
    }
    var flag = true,
        explain = '';
    //非空校验和自定义校验
    if (required && _lodashCompat2.default.isEmpty(value)) {
      explain = validation || '';
      flag = false;
    }
    if (flag && value && model.length >= minLength && value.length < minLength) {
      // 低于最少需选
      explain = lessLengthValidation || '';
      flag = false;
    }
    if (flag && value && value.length > maxLength) {
      // 高于最多可选
      explain = overLengthValidation || '';
      flag = false;
    }
    //自定义校验
    if (flag && validator) {
      //自定义校验
      if (_lodashCompat2.default.isFunction(validator)) {
        explain = validator(value);
        //返回字符串 不为空表示校验没通过 且返回错误提示
        if (!(0, _data.isEmptyString)(explain)) {
          flag = false;
        } else {
          explain = '';
        }
      }
    }
    _this3.state.explain = explain;
    _this3.state.valid = flag;
    _this3.forceUpdate();
    return flag;
  };

  this.reset = function () {
    //清空数据 并清空校验状态
    var _props4 = _this3.props;
    var mode = _props4.mode;
    var defaultValue = _props4.defaultValue;
    var onChange = _props4.onChange;

    var resetValue = _this3._getRenderValue(defaultValue);
    _this3._isReturnString(resetValue) && resetValue.length === 0 && (resetValue = '');
    if (mode !== 'view') {
      _this3.setState({ value: resetValue, valid: true, explain: '' }, function () {
        onChange(resetValue);
      });
    }
  };

  this.clear = function () {
    _this3.setState({ valid: true, explain: '' });
  };
}, _temp);
exports.default = CheckboxGroup;